import React from 'react';
import { PaymentWithDetails } from '../../types/payment.ts';
import { formatCurrency, formatDate } from '../../utils/formatters.ts';
import '../../styles/Receipt.css';

interface ReceiptProps {
	payment: PaymentWithDetails;
	onClose: () => void;
	onPrint: () => void;
}

const Receipt: React.FC<ReceiptProps> = ({ payment, onClose, onPrint }) => {
	// Function to determine payment description
	const getDescription = () => {
		if (payment.bill?.month) {
			return (
				<p>
					for the month of <strong>{payment.bill.month}</strong>
				</p>
			);
		}
		if (payment.notes) {
			return (
				<p>
					<strong>{payment.notes}</strong>
				</p>
			);
		}
		return null;
	};

	return (
		<div className='modal'>
			<div className='receipt-container' id='receipt-content'>
				<div className='receipt-header'>
					<h2>RENT RECEIPT</h2>
						<p className='receipt-no'>For: {payment.tenant.full_name}</p>
					<p className='receipt-no'>
						Receipt No: {payment.id.slice(0, 8).toUpperCase()}
					</p>
				</div>

				<div className='receipt-date'>
					<p>Date: {formatDate(payment.payment_date)}</p>
				</div>

				<div className='receipt-body'>
					<p>
						Received with thanks from{' '}
						<strong>{payment.tenant.full_name}</strong>
					</p>
					<p>
						a sum of{' '}
						<strong>{formatCurrency(payment.total_amount)}</strong>
					</p>
					<p>
						towards the rent of property{' '}
						<strong>{payment.property.name}</strong>
					</p>
					{getDescription()}
					<p>
						Payment Mode: <strong>{payment.payment_mode}</strong>
					</p>
					<p>
						Collected By: <strong>{payment.payment_to}</strong>
					</p>
				</div>

				<div className='receipt-footer'>
					<div className='receipt-signature'>
						<div className='signature-line'></div>
						<p>Authorized Signature</p>
					</div>
					<div className='receipt-stamp'></div>
				</div>

				<div className='receipt-actions'>
					<button onClick={onPrint} className='btn-primary'>
						Print Receipt
					</button>
					<button onClick={onClose} className='btn-secondary'>
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default Receipt;
